export default "__VITE_ASSET__vTDfybMV__"